import {
  Flex,
  Table,
  TableCaption,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { simplifiedExtract } from "../../../../interfaces/defaultInterfaces";
import moment from "moment";
import { ToLocaleFormat } from "../../../../defaultFunctions/formaters";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function TableRelease({ data, title }: any) {
  const [salesCredit, setSalesCredit] = useState(Array<simplifiedExtract>);
  useEffect(() => {
    setSalesCredit(data);
  }, [data]);
  const colors = useRecoilState(customColors)[0];

  return (
    <>
      {salesCredit.length && (
        <Flex w={"100%"} flexDirection={"column"} mt={4}>
          <Text m={4} fontSize={"16px"} fontWeight={"bold"}>
            {title}
          </Text>
          <Table variant={"striped"}>
            <TableCaption fontWeight={"bold"}>
              Total:{" "}
              {ToLocaleFormat(salesCredit.reduce((acc, i) => acc + i.valor, 0))}
            </TableCaption>
            <Thead
              h="60px"
              position="sticky"
              top="0"
              bgColor={colors.BLUEMONEDDBUTTONS}
            >
              <Tr>
                <Th
                  borderRadius={"8px 0 0 8px"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Data
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Tipo
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Observação
                </Th>
                <Th
                  borderRadius={"0 8px 8px 0"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Valor do Lançamento
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {salesCredit &&
                salesCredit.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td borderRadius={"8px 0 0 8px"}>
                        {moment(item?.dataLancamento).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      </Td>
                      <Td>{item?.tipoLancamento?.lancamento}</Td>
                      <Td>{item?.observacao}</Td>
                      <Td borderRadius={"0 8px 8px 0"}>
                        {item?.valor.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </Flex>
      )}
    </>
  );
}
